import React from "react";
import Divider from "@mui/material/Divider";
import { formattedPrice } from "../../../../../../views/pages/manage/edpOps/studentDetails/paymentSummary/advancePaymentDetails/paymentDialog/constant";

const REFUND_COMPONENTS = [
  {
    key: "cmpConcession",
    label: "CMPR",
    amountKey: "cmprRefundAmount",
  },
  {
    key: "admissionConcession",
    label: "Admission",
    amountKey: "admRefundAmount",
  },
  {
    key: "registrationConcession",
    label: "Registration",
    amountKey: "regRefundAmount",
  },
];

/**
 * Disable logic function
 */

const ViewConcessionRefundItems = ({ refundDetails = {} }) => {
    console.log("refundDetails in view concession", refundDetails);
  return (
    <div className="py-4">
      <Divider />

      {REFUND_COMPONENTS.map(({ key, label, amountKey }) => {
        const amount = refundDetails?.[amountKey] ?? 0;
        return (
          <div
            key={key}
            className="d-flex justify-content-between align-items-center mb-1"
          >
            <div>{label}</div>

            <div>{formattedPrice(amount)}</div>
          </div>
        );
      })}

      <Divider />
    </div>
  );
};

export default ViewConcessionRefundItems;
